export const mentalHealthTopicConstants = {
	TOPIC_ID: 'topicID',
	MH_ID: 'mhId',
};
